import React from "react";

function OurBlog() {
  return <div>OurBlog</div>;
}

export default OurBlog;
